/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_None4Inputs */

const en_cv_extract_form_enum_none4 = /** @type {(inputs: Cv_Extract_Form_Enum_None4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const de_cv_extract_form_enum_none4 = /** @type {(inputs: Cv_Extract_Form_Enum_None4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Cv_Extract_Form_Enum_None4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_none4 = /** @type {((inputs?: Cv_Extract_Form_Enum_None4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_None4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_none4(inputs)
	return en_cv_extract_form_enum_none4(inputs)
});
export { cv_extract_form_enum_none4 as "cv_extract_form_enum_NONE" }